<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/base/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>临床调研</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- <el-button size="small" type="primary" icon="el-icon-plus" @click="editFormVisible = true" style="margin-top: 20px;margin-bottom: 20px;">添加</el-button> -->
    <!--列表-->
    <el-table size="small" :header-cell-style="{background:'#00A0FF',color:'white',border: '1px solid tan'}"  :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;margin-top: 30px;" :row-class-name="tableRowClassName">
      <el-table-column align="center" type="index" label="序号"  width="50">
      </el-table-column>
     <!-- <el-table-column prop="uname"  align="center" label="姓名">
      </el-table-column>
      <el-table-column prop="idcard"  align="center" label="健康卡号">
      </el-table-column> -->

      <el-table-column prop="con"  align="center" label="调研内容">

          <template slot-scope="scope">
              <div v-for="item in scope.row.con">
                  <div>
                    {{item.ques}}:{{item.val}}
                  </div>

              </div>

          </template>
      </el-table-column>
      <el-table-column prop="createtime"  align="center" label="提交时间">
      </el-table-column>



      <el-table-column align="center" label="操作" width="180">
        <template slot-scope="scope">

          <el-button size="mini" type="danger" @click="delque(scope.row.id,scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

  </div>
</template>

<script>
  import Pagination from '../../components/Pagination'
  import { getlcdy,dellcdy } from '../../api/baseset'
  export default {
    data() {
      return {
        loading: false, //是显示加载
        editFormVisible: false,
        editForm: {
          status: '1',
          type: '1'
        },
        // rules表单验证

        // 请求数据参数
        formInline: {
          page: 1,
          limit: 10,
          key: ''
        },
        //表格数据
        listData: [],
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        }
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    created() {
      this.getdata(this.formInline)
    },
    methods: {
      getdata(param) {
        this.loading = true;
        getlcdy(param).then(res => {
          this.loading = false;
          this.listData = res.data;
          // 分页赋值
          this.pageparm.currentPage = this.formInline.page
          this.pageparm.pageSize = this.formInline.limit
          this.pageparm.total = res.count
        })
      },
      editFormreset() {
        this.editForm = {status: '1',type: '1'};
      },
      tableRowClassName({row, rowIndex}) {
              if (rowIndex % 2 ==1) {
                return 'success-row';
              }
              return '';
       },
      delque(id,index) {
        this.$confirm('您确定要删除吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let data = {id:id};
          dellcdy(data).then(res => {
            if(res.code == 0){
              this.listData.splice(index, 1);
              this.$message({
                type: 'success',
                message: res.msg
              });
            }else{
              this.$message.error(res.msg);
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      }
    }

  }
</script>

<style>
  .change{margin-top: 10px;}
   .el-table .success-row {
      background: #f0f9eb;
    }
</style>



// WEBPACK FOOTER //
// src/views/wenjuan/lcyjwtdy.vue